export const settingNames = ['SHIPPING_LABELS', 'PACKING_SLIPS', 'COMMERCIAL_INVOICE'];

export const settingsMap = {
  [settingNames[0]]: ['label_printer_id', 'label_tray_id'],
  [settingNames[1]]: ['packing_slip_printer_id', 'packing_slip_tray_id'],
  [settingNames[2]]: ['commercial_invoice_printer_id', 'commercial_invoice_tray_id']
};
